import '@/index.css';
import '@fontsource-variable/inter';
import '@fontsource-variable/fraunces/standard';
import 'swiper/css';
import 'swiper/css/pagination';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { UiKitLocalizationContext } from '@ui-kit/localization/UiKitLocalizationContext';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { StyleSheetManager } from 'styled-components';
import App from '@/components/App/App';
import GlobalStyle from '@/components/GlobalStyle';
import { getConfig } from '@/constants/config';
import { initializeGtm } from '@/integrations/gtm';
import { AppPostHogProvider } from '@/integrations/posthog';
import { initializeSentry } from '@/integrations/sentry';
import { queryClient } from '@/libs/tanstackQuery';
import initializeI18n from '@/localization/i18n';
import { isMockingEnabled } from '@/utils/env.utils';

initializeSentry();
initializeGtm();

const container = document.getElementById('root');
const rootElement = createRoot(container!);

void initializeI18n();

const enableMocking = async () => {
  if (isMockingEnabled()) {
    const { worker } = await import('@/stubs/msw/browser');
    void worker.start({ onUnhandledRequest: 'bypass' });
  }
};

void enableMocking().then(() => {
  rootElement.render(
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <GlobalStyle />
        <StyleSheetManager enableVendorPrefixes>
          <UiKitLocalizationContext locale={getConfig().locale}>
            <React.StrictMode>
              <AppPostHogProvider>
                <App />
              </AppPostHogProvider>
            </React.StrictMode>
          </UiKitLocalizationContext>
        </StyleSheetManager>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </BrowserRouter>,
  );
});
